module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABMElEQVRYR+2WYQrCMAxGk93D06mgIDuCmx5BBAX1dN5jEavDdbazaTIYmP3ulzxe03YIE/9w4nxggNIdMoNmUGpAmrcZ/F+Dq822wqKYnQ7VEgBJaiKcJ1yXuws1zf183O9Ca4Iz6OAQaxdAvI0D+YIDovmzDRHVIcgg4Lqsr21wHEgf7tOjXvQtRk5xrIDGdvNqD1wzvEJpM8qv+eMe5BeMg+bVSrio8wr7oPk1EgDdGfNOHO/gSLLA+WHNaZST8d0nGmxDnIactfHJZQKmbrcOnHsn0q6H/qohAIDuC8Gb12+aTMC4Sdfi/XxJ4QQGB2ayK0HhHRcY/AGpAKdgMAKpBKcI2JlJAND8PVPY4u7Q0bue3g+uMmDepTWUMkCpUzNoBqUGpHmbQTMoNSDNPwAZGP4pLaDaIgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_next@2x.png
// module id = 413
// module chunks = 1 2